import { dataLoading } from "@/shared/decorators/LoadingAction.decorator";
import apiClient from "./ApiClientService";
import { UserList } from "@/shared/models/UserList";
import { store } from "@/redux/store";
import { setToastError } from "@/redux/shareSlice";

export class UserListApi {
  @dataLoading([])
  static async getAllData(excludeReadOnly: boolean = false) {
    const query = excludeReadOnly ? `?excludeReadOnly=true` : "";
    const result = await apiClient.get(`/userlist/list${query}`);
    return result.status === 200 ? (result.data as UserList[]) : [];
  }

  @dataLoading({})
  static async checkUserRoles(userName: string, userId: string) {
    try {
      const url = `/userlist/loadcurrentuser?userName=${encodeURIComponent(userName)}&userId=${encodeURIComponent(userId)}`;
      const result = await apiClient.get(url);
      if (result.status === 200) {
        return result.data as UserList;
      }
      // Non-200: surface via toast
      store.dispatch(setToastError(`Failed to load current user (status ${result.status}).`));
      return {} as UserList;
    } catch (error: any) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message || error?.message || "Unknown error";
      store.dispatch(setToastError(`Error loading current user: ${serverMsg}${status ? ` (status ${status})` : ""}`));
      return {} as UserList;
    }
  }

  @dataLoading(false)
  static async updateUserList(userList: UserList) {
    try {
      console.log("🔄 Updating user roles:", {
        userId: userList.id,
        userRole: userList.userRole,
        apexId: userList.apexId,
      });

      const result = await apiClient.put(`/userlist`, {
        ID: userList.id,
        ApexId: userList.apexId,
        UserName: userList.userName,
        Email: userList.email,
        Team: userList.team,
        UserRole: userList.userRole,
        Domain: userList.domain,
      });

      if (result.status === 200) {
        console.log("✅ User roles updated successfully");
        return true;
      } else {
        console.error("❌ Failed to update user roles, status:", result.status);
        return false;
      }
    } catch (error) {
      console.error("❌ Error updating user roles:", error);
      return false;
    }
  }
}
